export enum RequestState {
    Completed = 0,
    Active = 1
  }
  